import { useState } from 'react';
import { formatPhone, toE164US } from '../../utils/phone';

// Phone OTP login. Lifted verbatim from the legacy AdminApp.js; only
// dependency is a Supabase client passed in (so tests can stub it).
export function Login({ supabase, onSession }) {
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState('phone');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const sendOtp = async () => {
    setError('');
    setLoading(true);
    try {
      const { error: e } = await supabase.auth.signInWithOtp({ phone: toE164US(phone) });
      if (e) throw e;
      setStep('code');
    } catch (e) {
      setError(e.message || 'Failed to send code');
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    setError('');
    setLoading(true);
    try {
      const { data, error: e } = await supabase.auth.verifyOtp({
        phone: toE164US(phone), token: code, type: 'sms',
      });
      if (e) throw e;
      onSession(data.session);
    } catch (e) {
      setError(e.message || 'Bad code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50 p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow p-6 space-y-4">
        <h1 className="text-xl font-semibold text-stone-800">Palate Admin</h1>
        {step === 'phone' && (
          <>
            <input
              type="tel"
              inputMode="numeric"
              value={formatPhone(phone)}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
              placeholder="(555) 123-4567"
              className="w-full border rounded-lg px-3 py-2 text-stone-900"
            />
            <button
              disabled={loading || phone.replace(/\D/g, '').length !== 10}
              onClick={sendOtp}
              className="w-full bg-stone-800 text-white rounded-lg py-2 disabled:opacity-50"
            >
              {loading ? 'Sending…' : 'Send code'}
            </button>
          </>
        )}
        {step === 'code' && (
          <>
            <p className="text-sm text-stone-600">Code sent to {formatPhone(phone)}</p>
            <input
              type="tel"
              inputMode="numeric"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="123456"
              className="w-full border rounded-lg px-3 py-2 text-stone-900 tracking-widest text-center"
            />
            <button
              disabled={loading || code.length !== 6}
              onClick={verifyOtp}
              className="w-full bg-stone-800 text-white rounded-lg py-2 disabled:opacity-50"
            >
              {loading ? 'Verifying…' : 'Verify'}
            </button>
            <button
              onClick={() => { setStep('phone'); setCode(''); }}
              className="w-full text-stone-500 text-sm"
            >
              Use a different number
            </button>
          </>
        )}
        {error && <p className="text-red-600 text-sm">{error}</p>}
      </div>
    </div>
  );
}
